<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <el-button type="primary"  @click="saveInterface">保存</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" v-loading="loading" @selection-change="selectChanges" row-key="id" border stripe ref="multipleTable">
                    <el-table-column type="selection" align="center" width="50"></el-table-column>
                    <el-table-column prop="interface_name" label="功能权限" sortable="custom"></el-table-column>
                </el-table>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil"
import { interfaceList, saveInterface } from '@/api/accesstoken'

export default {
    name: 'cryptoUserList',
    mixins: [listutil],
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        access_token_id: {
            type: Number,
            default() {
                return 0;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.loadData();
            }
        },
    },
    data() {
        return {
            m_name: 'Token分配权限',
            menu_id: 9999,
            showflag: false,
            search_Obj: {
                f_xxx: '',
            },
            selectedRowKeys: [],
        };
    },
    methods: {
        loadData(){
            this.loading = true;
            this.tableData = [];
            this.selectedRowKeys = []
            interfaceList(this.access_token_id).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.list;
                    if (this.$isNotNull(res.data.ids)) {
                        let t = res.data.ids.split(",")
                        for (let i=0;i<t.length;i++) {
                            this.selectedRowKeys.push(parseInt(t[i]))
                        }
                    }
                    setTimeout(() => {
                        this.tableData.forEach(row => {
                            if (this.selectedRowKeys.includes(row.id)) {
                                this.$refs.multipleTable.toggleRowSelection(row, true);
                            }
                        });
                    }, 200);
                }
            })
        },
        getData(){},
        closeDialog() {
            this.$emit("on-close")
        },
        saveInterface(){
            let ids = '';
            for (let data of this.selectData) {
                if (ids === '') {
                    ids = data.id + "";
                } else {
                    ids += "," + data.id;
                }
            }
            saveInterface(this.access_token_id, ids).then(res=>{
                if (res.code == 1) {
                    this.$msgs("绑定成功")
                } else {
                    this.$msg(res.msg)
                }
                this.closeDialog()
            })
        },
    }
};
</script> 